<!-- Modifica en CashbackNotification.vue, en la parte del script -->

<script>
import { computed, ref, onMounted, watch } from 'vue'
import { usePlayerStore } from '../stores/player/playerStore'
import { useGamesStore } from '../stores/games/gamesStore' // Añadir esta importación
import { useI18n } from 'vue-i18n'

export default {
  name: 'CashbackNotification',
  setup() {
    const { t } = useI18n()
    const playerStore = usePlayerStore()
    const gamesStore = useGamesStore() // Añadir esta línea
    const isVisible = ref(true)
    const timeoutId = ref(null)

    const notification = computed(() => ({
      show: playerStore.cashbackNotification.show && isVisible.value,
      amount: playerStore.cashbackNotification.amount
    }))

    // Formatear el monto para mostrar dos decimales
    const formattedAmount = computed(() => {
      return Number(notification.value.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    })

    const clearNotification = () => {
      isVisible.value = false
      setTimeout(() => {
        playerStore.clearCashbackNotification()
      }, 500)
    }

    const setupAutoHide = () => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value)
      }
      
      timeoutId.value = setTimeout(() => {
        isVisible.value = false
        setTimeout(() => {
          playerStore.clearCashbackNotification()
        }, 500)
      }, 120000) // 2 minutos
    }

    // Si se muestra esta notificación, ocultar la de error del juego
    watch(() => notification.value.show, (show) => {
      if (show && gamesStore.activeGame?.error === 'need_balance_to_launch') {
        gamesStore.activeGame = null
      }
    })

    onMounted(() => {
      if (playerStore.cashbackNotification && playerStore.cashbackNotification.show) {
        // Si hay una notificación de error del juego, ocultarla
        if (gamesStore.activeGame?.error === 'need_balance_to_launch') {
          gamesStore.activeGame = null
        }
        setupAutoHide()
      }
    })

    watch(() => playerStore.cashbackNotification.show, (show) => {
      if (show) {
        // Si hay una notificación de error del juego, ocultarla
        if (gamesStore.activeGame?.error === 'need_balance_to_launch') {
          gamesStore.activeGame = null
        }
        isVisible.value = true
        setupAutoHide()
      }
    })

    return {
      notification,
      formattedAmount,
      clearNotification,
      t
    }
  }
}
</script>
<template>
  <transition name="fade">
    <div v-if="notification.show" class="cashback-notification">
      <div class="notification-content">
        <p>
          {{ t('cashback.notify_bonus_message') }} {{ formattedAmount }}!
        </p>
        <button @click="clearNotification" class="close-notification">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.cashback-notification {
  position: fixed;
  top: 10px;
  right: 10px;
  background: #01167e;
  color: #fcfdff;
  border: 2px solid #fff81f;
  padding: 10px 20px;
  border-radius: 4px;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  animation: slide-in 0.5s ease-out;
}

.notification-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px; /* Espacio entre el texto y el botón X */
}

.close-notification {
  background: #fff81f; /* Fondo amarillo como el borde */
  border: none;
  border-radius: 50%; /* Hacerlo circular */
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  color: #01167e; /* Color azul oscuro */
  padding: 0;
  transition: all 0.2s ease;
}

.close-notification:hover {
  transform: scale(1.1);
  background: #ffffff; /* Cambiar a blanco en hover */
}

/* Animaciones */
.fade-enter-active {
  animation: slide-in 0.5s;
}
.fade-leave-active {
  animation: slide-out 0.5s;
}

@keyframes slide-in {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
}
</style>